module.exports = __webpack_public_path__ + "img/add.5869e099.svg";